
import { useStore } from "@/store";
import { defineComponent } from "vue";
import IconVue from "./Icon.vue";

export default defineComponent({
  components: {
    IconVue,
  },
  computed: {
    classes() {
      return useStore().state.courses;
    },
  },
});
